import React, { Component } from 'react';

import { Route, Link } from 'react-router-dom';

import networkRenamer from './networkRenamer.js';
import appRenamer from './appRenamer.js';

import './css/topbar.css';


export default class TopBar extends Component{

  constructor(props){
    super(props);

    this.routes = {
      '/': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Dashboard</li>
        </ul>
      ),
      '/dashboard': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Dashboard</li>
        </ul>
      ),
      '/dashboard/:date': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Dashboard</li>
        </ul>
      ),
      '/docs': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Docs</li>
        </ul>
      ),
      '/docs/:clientId': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Docs</li>
        </ul>
      ),
      '/billing': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Billing</li>
        </ul>        
      ),
      '/apps': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li className="active">Apps</li>
        </ul>
      ),
      '/apps/create': () => (
        <ul id="breadcrumbs" className="breadcrumb pull-left">
          <li><Link to="/">AppBid</Link></li>
          <li><Link to="/apps">Apps</Link></li>
          <li className="active">Create New App</li>
        </ul>
      ),      
      '/dashboard/:date/:app': ({match}) => {

        // find proper app
        let app = appRenamer(this.props.apps,match.params.app);        
        
        return (
          <ul id="breadcrumbs" className="breadcrumb pull-left">
            <li><Link to="/">AppBid</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li className="active">{app.name}</li>
          </ul>
        );
      },
      '/dashboard/:date/:app/:network':({match}) => {

        let network = networkRenamer(match.params.network);
        
        // find proper app
        let app = appRenamer(this.props.apps,match.params.app);        

        return (
          <ul id="breadcrumbs" className="breadcrumb pull-left">
            <li><Link to="/">AppBid</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to={`/dashboard/${match.params.date}/${app.clientId}`}>{app.name}</Link></li>
            <li className="active">{network}</li>
          </ul>
        );
      }
    };
    
  }
  
  render() {

    let routes = Object.entries(this.routes)
        .map(([path, component], idx) => 
             <Route
             key={idx}
             path={path}
             exact={true}
             component={component}/>);
          
    return (
      <nav className="topbar navbar navbar-fixed">
        <div className="container-fluid no-gutter">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navigation-example-2">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          {routes}
          <div className="sidebar-buttons collapse navbar-collapse pull-right">
            <Link to="/apps/create" className="btn btn-primary" role="button">
              <i className="fa fa-plus-circle" aria-hidden="true"></i>
              Create App
            </Link>

            <div className="btn-group">
              <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                {this.props.user} <span className="caret"></span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a href="/logout.php">Logout</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/topbar.js